import { render, staticRenderFns } from "./checkoutButton.vue?vue&type=template&id=3aeaa596&lang=pug"
import script from "./checkoutButton.vue?vue&type=script&lang=js"
export * from "./checkoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports